<script setup lang="ts">
import { ref } from 'vue'

const tools = ref([
  {
    id: 1,
    name: 'Structural Health Monitoring',
    description: 'Precise radar measurements of structural deformation and displacement, for long term monitoring of critical infrastructure.',
    link: 'https://tool1.com',
    img: new URL('@/assets/shm.png', import.meta.url).href
  },
  {
    id: 2,
    name: 'Coastal Defence Monitoring',
    description: 'Measurements of slope instability, coastal erosion, and deformation of coastal defences.',
    link: 'https://tool2.com',
    img: new URL('@/assets/cdm.png', import.meta.url).href
  },
  {
    id: 3,
    name: 'Change Detection and Alerts',
    description: 'Activity in remote sensing data requiring attention, such as significant deformation or unexpected changes in observations which could indicate a problem.',
    link: 'https://tool3.com',
    img: new URL('@/assets/cda.png', import.meta.url).href
  }
])
</script>

<template class="container">
  <h1 class="centered">Select a Monitoring Tool</h1>
  <Divider />
  <div class="card-container">
    <!-- Three cards -->

    <div v-for="(item, index) in tools" :key="index">
      <Card style="width: 25rem; overflow: hidden">
        <template #header>
          <img
            class="short centered-image"
            :alt="item.name + ' logo'"
            :src="item.img"
            width="400px"
          />
          <Divider />
        </template>
        <template #content>
          <h2>{{ item.name }}</h2>
          <p>{{ item.description }}</p>
        </template>
      </Card>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10%;
  width: 100%;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 5%;
}
.centered {
  width: 100%;
  text-align: center;
}
</style>
